import { VariableSizeList as List } from "react-window";
import { useMemo, useRef, useEffect } from "react";

const OptimizedUserList1 = ({
  Manage,
  searchQuery,
  selectedUsers,
  handleToggleUser,
  userinstData
}) => {
  const listRef = useRef(null);

  const { groupedUsers } = useMemo(() => {
    const searchTerms = searchQuery.toLowerCase().split(/\s+/).filter(Boolean);

    // Filtrare după termeni de căutare
    const filtered = Manage.filter((user) => {
      const userInstData = userinstData.filter(
        i => i.institute_assign_id === user.institute_assign_id
      );

      const searchFields = [
        user.user_name_surname?.toLowerCase(),
        ...userInstData.map(i => i.spec ? i.spec.toLowerCase() : ''),
        ...userInstData.map(i => i.inst ? i.inst.toLowerCase() : ''),
        ...userInstData.map(i => i.city_name ? i.city_name.toLowerCase() : '')
      ].filter(Boolean);

      return searchTerms.every(term =>
        searchFields.some(field => field.includes(term))
      );
    });

    // Grupare pe user_name_surname, păstrând toate detaliile unice
    const mapByName = new Map();

    filtered.forEach(user => {
      const key = user.user_name_surname || `user-${user.institute_assign_id}`;
      const userInstData = userinstData.filter(
        i => i.institute_assign_id === user.institute_assign_id
      );

      if (!mapByName.has(key)) {
        mapByName.set(key, {
          user_name_surname: user.user_name_surname,
          data_acord: Boolean(user.data_acord === 1 || user.data_acord === true),
          details: new Map()
        });
      }

      const current = mapByName.get(key);
      if (user.data_acord === 1 || user.data_acord === true) {
        current.data_acord = true;
      }

      userInstData.forEach(i => {
        if (i.data_acord === 1 || i.data_acord === true) {
          current.data_acord = true;
        }
        const detailKey = `${i.spec}-${i.inst}-${i.city_name}-${user.institute_assign_id}`;
        if (!current.details.has(detailKey)) {
          current.details.set(detailKey, {
            institute_assign_id: user.institute_assign_id,
            spec: i.spec || null,
            institute: i.inst || null,
            city: i.city_name || null
          });
        }
      });
    });

    // Transformăm detaliile în array-uri
    const groupedUsers = Array.from(mapByName.values()).map(u => ({
      user_name_surname: u.user_name_surname,
      data_acord: u.data_acord,
      details: Array.from(u.details.values()),
    }));

    console.log('Grouped Users:', groupedUsers); // Debug
    return { groupedUsers };
  }, [Manage, searchQuery, userinstData]);

  const getItemSize = (index) => {
    const user = groupedUsers[index];
    if (!user || !user.details) return 70;
    
    // Calculăm înălțimea dinamică bazată pe numărul de detalii
    const baseHeight = 40; // Înălțime pentru nume
    const detailHeight = 30; // Înălțime pentru fiecare detaliu
    return baseHeight + (user.details.length * detailHeight);
  };

  useEffect(() => {
    if (listRef.current) {
      listRef.current.resetAfterIndex(0);
    }
  }, [groupedUsers]);

  const Row = ({ index, style }) => {
    const user = groupedUsers[index];
    
    // Debug detaliat
    console.log(`Row ${index}:`, user);
    
    if (!user || !user.user_name_surname) {
      console.log(`Row ${index}: User invalid sau fără nume`, user);
      return (
        <div style={style} className="flex flex-col gap-1 p-2 border-b">
          <h3 className="text-red-500">Eroare: User invalid</h3>
        </div>
      );
    }

    return (
      <div style={style} className="flex flex-col gap-1 p-2 border-b">
        <h3 className="text-gray-900 dark:text-gray-100 font-medium truncate flex items-center gap-1.5">
          <span>{user.user_name_surname || `Doctor ${index}`}</span>
          {user.data_acord ? (
            <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
              <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            </span>
          ) : null}
        </h3>
        <div className="flex flex-col gap-1 text-sm text-gray-500 dark:text-gray-400">
          {user.details && user.details.map((d, i) => {
            const label = [d.spec, d.institute, d.city].filter(Boolean).join(' - ');
            const isSelected = selectedUsers.includes(d.institute_assign_id);

            return (
              <label key={`${d.institute_assign_id}-${i}`} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  className="h-4 w-4"
                  checked={isSelected}
                  onChange={() =>
                    handleToggleUser(d.institute_assign_id, 'physician')
                  }
                />
                <span className="truncate">{label || `Detaliu ${i + 1}`}</span>
              </label>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="m-2">
        Doctori selectați: {selectedUsers.length}
      </div>
      {groupedUsers.length === 0 ? (
        <div className="p-4 text-center text-gray-500 dark:text-gray-400">
          Nu s-au găsit doctori care să corespundă căutării.
        </div>
      ) : (
        <List
          ref={listRef}
          height={300}
          itemCount={groupedUsers.length}
          itemSize={getItemSize}
          width="100%"
          overscanCount={5}
        >
          {Row}
        </List>
      )}
    </>
  );
};

export default OptimizedUserList1;